import { newRequestMercurio } from "std/api/mercurio/newRequestMercurio";
import type { ApiFinanceiroBanco, ApiFinanceiroBancoGetParams } from "../types/ApiFinanceiroBanco";

export function apiFinanceiroBancoGet(params?: ApiFinanceiroBancoGetParams): Promise<ApiFinanceiroBanco[]> {
	return newRequestMercurio({
		url: "FinanceiroBanco/FinanceiroBanco",
		type: "get",
		params,
	});
}
